import React, { useState, useEffect, useMemo, useRef } from 'react';
import moment from 'moment';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import '../../../../../common/css/timeLive.css';
import { useAppSelector, useAppDispatch } from '../../../../../app/hooks';
import Select, { StylesConfig } from 'react-select';
import { ShowToast } from '../../../../../common/Toastr';
import clsx from 'clsx';
import DescriptionWidget from '../../../../../features/timesheet/DescriptionWidget';
import TimesheetCopyWidget from '../../../../../features/timesheet/TimesheetCopyWidget';
import TimesheetMoreOptionWidget from '../../../../../features/timesheet/TimesheetMoreOptionWidget';
import TimesheetExportWidget from '../../../../../features/timesheet/TimesheetExportWidget';
import { Tooltip } from 'react-tooltip';
import TimesheetPrintViewWidget from '../../../../../features/timesheet/TimesheetPrintViewWidget';
/* import { formatDateWithDateAndMonthName } from '../../../../../common/timesheetFunction'; */
import {
    updateCurrentDate, getEmployeeAsync, updateAccountEmployeeId, submittedTimesheetAsync, updateIsLoading, updateValuesFromGlobalState,
    updateTimeEntryPeriodIdForPrint, updateTimesheetAttachment,
    updateApprovalDetails, updateLockingDateArray, setTimerPulsing
} from '../../../../../features/timesheet/timesheetSlice';
import { resetAttachmentList } from '../../../../../features/attachment/AttachmentSlice';
import { AttachmentUpload } from '../../../../../features/attachment/AttachmentUpload';
import GetAttachments from '../../../../../features/attachment/AttachmentItem';
import { KTSVG, KTIcon } from '../../../../helpers';
import { ShowSwalWithConfirmation } from '../../../../../common/SweetAlert';
import fetchAPI from '../../../../../common/fetchAPI';
import { useTranslation } from 'react-i18next';
import { formatDateWithDateAndMonthName, getValueFromResource } from '../../../../../common/timeLiveFunction';
import { MenuComponent } from '../../../../assets/ts/components/MenuComponent';

const itemClass = 'ms-1 ms-lg-0';

const ToolbarTimesheet = () => {
    const dispatch = useAppDispatch();
    const { t } = useTranslation();

    const modelRefSheetApproval = useRef<any>(null);
    const [singleDate, setSingleDate] = useState<Date | null>(new Date());
    const [employeeName, setEmployeeName] = useState<String | ''>('');
    const [isEmployeeUpdate, setIsEmployeeUpdate] = useState(false);
    const { currentDate, startDate, endDate, employeeList, accountEmployeeId, accountEmployeeTimeEntryPeriodId, isLocked, decimalTotalHours, isShowAttachment, showCopyTimesheet,
        showCopyActivityTimesheet, enableOfflineTimesheet, timesheetSubmissionMessage, timeEntriesList, isSubmitted, lockingDateArray, lockPreviousNextMonthTimesheetOn, autoTimer } = useAppSelector((state) => state.timesheet);
    const { cultureInfoName, accountIdsForAllocationHours, allocationHoursInProjectTaskTeam, allocationHoursInProjectTeam, sessionAccountEmployeeId, dateInsertionFormat, calendarStartDay, enableUploadFeature } = useAppSelector((state) => state.globalState);
    const [isSearchable, setIsSearchable] = useState(true);
    const [selectedOption, setSelectedOption] = useState<{ [object: string]: any }>();
    const [employeeArray, setEmployeeArray] = useState<any | ''>([]);
    const [isOpenTimesheetPrintModal, setIsOpenTimesheetPrintModal] = useState<any>();
    const modelRef = useRef<any>(null);
    const modelAttachmentRef = useRef<any>(null);

    const hasUnsubmittedEntries = useMemo(() => {
        if (!timeEntriesList || !Array.isArray(timeEntriesList)) return false;

        return timeEntriesList.some((row: any) => {
            const entries = row?.timeEntries || row?.timeentries;
            if (entries && Array.isArray(entries)) {
                return entries.some((entry: any) => entry?.status === "record-not-submitted");
            }
            return false;
        });
    }, [timeEntriesList]);


    const isSubmitButtonLocked = isLocked && !hasUnsubmittedEntries;

    //Attachment Work
    // const modalAttachmentRef = useRef<any>(null);
    // const [tempAttachmentId, setTempAttachmentId] = useState(null);
    // const [modalIsOpen, setModalIsOpen] = useState(false);
    // const attachmentUploadClearRef = useRef<any>(null);
    // useEffect(() => {
    //     if (modalIsOpen) {
    //         if (modalAttachmentRef.current) {
    //             modalAttachmentRef.current.click();
    //         }
    //     }
    // }, [modalIsOpen]);
    // const handleAttachment = (accountEmployeeTimeEntryPeriodId: any) => {
    //     dispatch(resetAttachmentList());
    //     setModalIsOpen(true);
    // }
    // const updateTempAttachmentId = (value: any) => {
    //     setTempAttachmentId(value);
    // };
    //Attachment Work

    useEffect(() => {
        accountEmployeeId == 0 && dispatch(updateValuesFromGlobalState(sessionAccountEmployeeId));
        document.body.setAttribute('data-kt-app-toolbar-fixed', 'true');
        accountEmployeeId != 0 && dispatch(getEmployeeAsync());
    }, [accountEmployeeId]);

    const onEmployeeChange = (data: any) => {
        setIsEmployeeUpdate(true);
        accountEmployeeId != data.value && dispatch(updateAccountEmployeeId(data.value));
        setSelectedOption(data);
    }

    const onDateChange = (date: any) => {
        dispatch(updateCurrentDate({ "date": moment(date).format(dateInsertionFormat), "mode": 'current' }));
        setSingleDate(date);
    };

    const onCurrentDateChange = (date: any) => {
        if (moment(date).format(dateInsertionFormat) < moment(startDate).format(dateInsertionFormat) || moment(date).format(dateInsertionFormat) > moment(endDate).format(dateInsertionFormat)) {
            dispatch(updateCurrentDate({ "date": moment(date).format(dateInsertionFormat), "mode": 'current' }));
            setSingleDate(date);
        }
    }

    const setTimsheetDate = (action: string) => {
        let newDate = currentDate;
        switch (action) {
            case "previous":
                newDate = moment(startDate).subtract(1, "days").format(dateInsertionFormat);
                dispatch(updateCurrentDate({ "date": newDate, "mode": 'previous' }));
                setSingleDate(moment(newDate).toDate());
                break;
            case "current":
                newDate = moment().format(dateInsertionFormat);
                dispatch(updateCurrentDate({ "date": newDate, "mode": 'current' }));
                setSingleDate(new Date());
                break;
            case "next":
                newDate = moment(endDate).add(1, "days").format(dateInsertionFormat);
                dispatch(updateCurrentDate({ "date": newDate, "mode": 'next' }));
                setSingleDate(moment(newDate).toDate());
                break;
            default:
                newDate = currentDate;
        }
    }
    let getEmployeeName = '';
    let array: any[] = [];

    employeeList?.map(item => {
        array.push({ value: item.AccountEmployeeId, label: item.EmployeeName })
        if (item != undefined && Number(item.AccountEmployeeId) == accountEmployeeId) {
            getEmployeeName = item.EmployeeName;
        }
    });

    if (getEmployeeName != employeeName && getEmployeeName != undefined && isEmployeeUpdate == false) {
        setEmployeeName(getEmployeeName);
        if (array[0] != undefined) {
            setSelectedOption(array.filter(x => x.value == accountEmployeeId)[0]);
        }
        setEmployeeArray(array);
    }

    const ValidateProjectAndTaskAllocationHoursByDate = async () => {
        dispatch(updateIsLoading(true));
        let tempAccountProjectTaskId: any[] = [];
        let timeEntryDate: any[] = [];
        let tempAccountProjectId: any[] = [];
        let tempTotalHours: any[] = [];
        timeEntriesList.map((item: any) => {
            if (item.AccountProjectTaskId != null) {
                tempAccountProjectId.push(item.AccountProjectId);
                tempAccountProjectTaskId.push(item.AccountProjectTaskId);
                tempTotalHours.push(item.Total);
            }
        });
        const postObject = {
            AccountEmployeeId: accountEmployeeId,
            AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
            AccountProjectTaskId: tempAccountProjectTaskId.toString(),
            AccountProjectId: tempAccountProjectId.toString(),
            TotalHours: tempTotalHours.toString(),
            AllocationHoursInProjects: Number(allocationHoursInProjectTeam) === 1 ? true : false,
            AllocationHoursInProjectTask: allocationHoursInProjectTaskTeam
        }
        const response = await fetchAPI('api/Timesheets/ValidateProjectAndTaskAllocationHoursByDate', 'POST', postObject, true);
        const json = await response.json();
        return json
    }
    const validateTaskEmployeeAllocationHoursByDate = async () => {
        dispatch(updateIsLoading(true));
        let tempAccountProjectTaskId: any[] = [];
        let timeEntryDate: any[] = [];
        let tempAccountProjectId: any[] = [];
        let tempTotalHours: any[] = [];
        timeEntriesList.map((item: any) => {
            if (item.AccountProjectTaskId != null) {
                tempAccountProjectId.push(item.AccountProjectId);
                tempAccountProjectTaskId.push(item.AccountProjectTaskId);
                tempTotalHours.push(item.Total);
            }
        });
        const postObject = {
            AccountEmployeeId: accountEmployeeId,
            AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
            AccountProjectTaskId: tempAccountProjectTaskId.toString(),
            AccountProjectId: tempAccountProjectId.toString(),
            TotalHours: tempTotalHours.toString(),
            AllocationHoursInProjects: Number(allocationHoursInProjectTeam) === 1 ? true : false,
            AllocationHoursInProjectTask: allocationHoursInProjectTaskTeam
        }
        const response = await fetchAPI('api/Timesheets/v2/ValidateTaskEmployeeAllocationHoursByDate', 'POST', postObject, true);
        const json = await response.json();
        return json
    }
    const validateProjectEmployeeAllocationHoursByDate = async () => {
        dispatch(updateIsLoading(true));
        let tempAccountProjectTaskId: any[] = [];
        let timeEntryDate: any[] = [];
        let tempAccountProjectId: any[] = [];
        let tempTotalHours: any[] = [];
        timeEntriesList.map((item: any) => {
            if (item.AccountProjectTaskId != null) {
                tempAccountProjectId.push(item.AccountProjectId);
                tempAccountProjectTaskId.push(item.AccountProjectTaskId);
                tempTotalHours.push(item.Total);
            }
        });
        const postObject = {
            AccountEmployeeId: accountEmployeeId,
            AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
            AccountProjectTaskId: tempAccountProjectTaskId.toString(),
            AccountProjectId: tempAccountProjectId.toString(),
            TotalHours: tempTotalHours.toString(),
            AllocationHoursInProjects: Number(allocationHoursInProjectTeam) === 1 ? true : false,
            AllocationHoursInProjectTask: allocationHoursInProjectTaskTeam
        }
        const response = await fetchAPI('api/Timesheets/v2/ValidateProjectEmployeeAllocationHoursByDate', 'POST', postObject, true);
        const json = await response.json();
        return json
    }

    const validateTaskAllocationHours = async () => {
        dispatch(updateIsLoading(true));
        let tempAccountProjectTaskId: any[] = [];
        let timeEntryDate: any[] = [];
        let tempAccountProjectId: any[] = [];
        let tempTotalHours: any[] = [];
        timeEntriesList.map((item: any) => {
            if (item.AccountProjectTaskId != null) {
                tempAccountProjectId.push(item.AccountProjectId);
                tempAccountProjectTaskId.push(item.AccountProjectTaskId);
                tempTotalHours.push(item.Total);
                timeEntryDate.push(item.timeEntryDate);
            }
        });
        const postObject = {
            AccountEmployeeId: accountEmployeeId,
            AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
            AccountProjectTaskId: tempAccountProjectTaskId.toString(),
            AccountProjectId: tempAccountProjectId.toString(),
            TotalHours: tempTotalHours.toString(),
            AllocationHoursInProjects: Number(allocationHoursInProjectTeam) === 1 ? true : false,
            AllocationHoursInProjectTask: allocationHoursInProjectTaskTeam,
            TimeEntryDate: timeEntryDate
        }
        const response = await fetchAPI('api/Timesheets/v2/ValidateAllocationHours', 'POST', postObject, true);
        const json = await response.json();
        return json
    }

    const submitTimesheet = () => {
        let base_url = window.origin + '/';
        const submitObject = {
            AccountEmployeeId: accountEmployeeId,
            AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
            StartDate: startDate,
            EndDate: endDate,
            Link: `${base_url}`,
        }
        dispatch(submittedTimesheetAsync(submitObject))
            .unwrap()
            .then((originalPromiseResult) => {
                if (originalPromiseResult.result.length > 0) {
                    if (originalPromiseResult.result[0].IsError == undefined) {
                        ShowToast('Success', 'Timesheet Submitted Successfully!', "success", "toast-top-right");
                    } else {
                        ShowToast('Warning', originalPromiseResult.result[0].ErrorMessage, "warning", "toast-top-right");
                    }
                }
                else {
                    ShowToast('error', 'Timesheet is not Submitted Successfully!', "error", "toast-top-right");
                }
            })
            .catch((rejectedValueOrSerializedError) => {
            })
            .finally(() => {
            });
    }

    const onSubmittedTimesheet = () => {
        ShowSwalWithConfirmation(getValueFromResource("Timesheet Submission Confirmation", dispatch, t), timesheetSubmissionMessage, "Confirm")
            .then((result) => {
                if (result) {
                    
                    let isOnlyTimeOff = true;
                    timeEntriesList.map((item: any) => {
                        if (item.AccountClientId != null && item.AccountProjectId != null && item.isTimeOff != "1") {
                            isOnlyTimeOff = false;
                        }
                    });
                    if (isOnlyTimeOff) {
                        submitTimesheet();
                    } else {
                        // New condition added here
                        if (accountIdsForAllocationHours) {
                            ValidateProjectAndTaskAllocationHoursByDate().then((result) => {
                                if (Number(result.id) > 0) {
                                    submitTimesheet();
                                } else {
                                    dispatch(updateIsLoading(false));
                                    ShowToast('Warning', result[0].message, "warning", "toast-top-right");
                                }
                            }).catch((error) => {
                                // Handle error if needed
                            });
                        }
                        else if (allocationHoursInProjectTaskTeam || allocationHoursInProjectTeam) {
                            validateTaskAllocationHours().then((result) => {
                                if (Number(result.id) > 0) {
                                    submitTimesheet();
                                } else {
                                    dispatch(updateIsLoading(false));
                                    ShowToast('Warning', result.message, "warning", "toast-top-right");
                                }
                            }).catch((error) => {
                                // Handle error if needed
                            });
                        } else {
                            submitTimesheet();
                        }
                    }
                }
            })
            .catch((error) => {
                dispatch(updateIsLoading(false));
            });
    };

    const onSubmittedTimesheetOld = () => {
        ShowSwalWithConfirmation("Timesheet Submission Confirmation", timesheetSubmissionMessage, "Confirm")
            .then((result) => {
                if (result) {
                    let isOnlyTimeOff = true;
                    timeEntriesList.map((item: any) => {
                        if (item.AccountClientId != null && item.AccountProjectId != null && item.isTimeOff != "1") {
                            isOnlyTimeOff = false;
                        }
                    });
                    if (isOnlyTimeOff) {
                       
                        submitTimesheet();
                    } else {
                       
                        if (accountIdsForAllocationHours) {
                            ValidateProjectAndTaskAllocationHoursByDate().then((res) => {
                                if (Number(res.id) > 0) {
                                    submitTimesheet();
                                } else {
                                    dispatch(updateIsLoading(false));
                                    ShowToast('Warning', res[0].message, "warning", "toast-top-right");
                                }
                            }).catch((error) => {
                                dispatch(updateIsLoading(false));
                            });
                        } else if (allocationHoursInProjectTaskTeam || allocationHoursInProjectTeam) {
                            validateTaskAllocationHours().then((result) => {
                                if (Number(result.id) > 0) {
                                    submitTimesheet();
                                } else {
                                    dispatch(updateIsLoading(false));
                                    ShowToast('Warning', result[0].message, "warning", "toast-top-right");
                                }
                            }).catch((error) => {
                                dispatch(updateIsLoading(false));
                            });
                        }
                        else {
                            submitTimesheet();
                        }
                    }
                }
            })
            .catch((error) => {
                dispatch(updateIsLoading(false));
            });
        //Old Submit
        // const postObject = {
        //     AccountEmployeeId: accountEmployeeId,
        //     AccountEmployeeTimeEntryPeriodId: accountEmployeeTimeEntryPeriodId,
        //     StartDate: startDate,
        //     EndDate: endDate
        // }
        // ShowSwalWithConfirmation(timesheetSubmissionMessage, '', "Yes, Submitted!")
        //     .then((result) => {
        //         if (result) {
        //             dispatch(submittedTimesheetAsync(postObject))
        //                 .unwrap()
        //                 .then((originalPromiseResult) => {
        //                     if (originalPromiseResult.length > 0) {
        //                         if (originalPromiseResult[0].IsError == undefined) {
        //                             ShowToast('Success', 'Timesheet Submitted Successfully!', "success", "toast-top-right");
        //                         } else {
        //                             ShowToast('Warning', originalPromiseResult[0].ErrorMessage, "warning", "toast-top-right");
        //                         }
        //                     }
        //                     else {
        //                         ShowToast('error', 'Timesheet is not Submitted Successfully!', "error", "toast-top-right");
        //                     }
        //                 })
        //                 .catch((rejectedValueOrSerializedError) => {
        //                 })
        //                 .finally(() => {
        //                 });
        //         }
        //     })
        //     .catch((error) => {
        //     });
    }

    const getStartDate = useMemo(() => {
        return formatDateWithDateAndMonthName(startDate, cultureInfoName.toString())
    }, [startDate])

    const getEndDate = useMemo(() => {
        return formatDateWithDateAndMonthName(endDate, cultureInfoName.toString())
    }, [endDate])

    // const triggerTimesheetPrintView = () => {
    //     decimalTotalHours > 0 ?
    //         setIsOpenTimesheetPrintModal(accountEmployeeTimeEntryPeriodId) :
    //         ShowToast('', 'No Record Found!', "error", "toast-top-right");
    // }

    useMemo(() => {
        // getAllDatesAroundCurrentMonth();
        getAllCurrentDates();
    }, [lockPreviousNextMonthTimesheetOn]);

    const triggerTimesheetPrintView = () => {
        if (decimalTotalHours > 0) {
            modelRef.current.click();
            dispatch(updateTimeEntryPeriodIdForPrint({ timeEntryPeriodIdForPrint: accountEmployeeTimeEntryPeriodId, isForTimesheet: true }));
        } else {
            modelRef.current.close();
            ShowToast('', 'No Record Found!', "error", "toast-top-right");
        }
    }

    const triggerTimesheetAttachmentView = () => {
        dispatch(resetAttachmentList());
        modelAttachmentRef.current.click();
        dispatch(updateTimesheetAttachment(true));
    }

    const handleOnClickApprovalEvent = () => {
        if (decimalTotalHours > 0) {
            modelRefSheetApproval.current.click();
            dispatch(updateApprovalDetails({ timeEntryPeriodIdForApproval: accountEmployeeTimeEntryPeriodId, isApprovalDetail: true }));
        } else {
            modelRefSheetApproval.current.close();
            ShowToast('', 'No Record Found!', "error", "toast-top-right");
        }
    }

    // function getAllDatesAroundCurrentMonth() {
    //     const today = new Date();
    //     const currentYear = today.getFullYear();
    //     const currentMonth = today.getMonth();
    //     const monthsToInclude = [
    //         { year: currentYear, month: currentMonth - 1 },
    //         { year: currentYear, month: currentMonth + 1 }
    //     ];
    //     const normalizedMonths = monthsToInclude.map(({ year, month }) => {
    //         const newDate = new Date(year, month);
    //         return { year: newDate.getFullYear(), month: newDate.getMonth() };
    //     });
    //     const allDates: Date[] = [];
    //     const dates: any = [];
    //     normalizedMonths.forEach(({ year, month }) => {
    //         const date = new Date(year, month, 1);
    //         while (date.getMonth() === month) {
    //             allDates.push(new Date(date));
    //             date.setDate(date.getDate() + 1);
    //             dates.push(date.toISOString().split("T")[0]);
    //         }
    //     });
    //     dispatch(updateLockingDateArray(dates));
    // }

    function getAllCurrentDates() {
        if (Number(moment(new Date()).format(dateInsertionFormat).split("-")[2]) === Number(lockPreviousNextMonthTimesheetOn)) {
            const today = new Date();
            const currentYear = today.getFullYear();
            const currentMonth = today.getMonth();
            const monthsToInclude = [{ year: currentYear, month: currentMonth }];
            const normalizedMonths = monthsToInclude.map(({ year, month }) => {
                const newDate = new Date(year, month);
                return { year: newDate.getFullYear(), month: newDate.getMonth() };
            });
            const allDates: Date[] = [];
            const dates: any = [];
            normalizedMonths.forEach(({ year, month }) => {
                const date = new Date(year, month, 1);
                while (date.getMonth() === month) {
                    allDates.push(new Date(date));
                    date.setDate(date.getDate() + 1);
                    dates.push(date.toISOString().split("T")[0]);
                }
            });
            dispatch(updateLockingDateArray(dates));
        }
    }
    useEffect(() => {
        if ((showCopyTimesheet || showCopyActivityTimesheet) && !isLocked) {
            setTimeout(() => {
                MenuComponent.createInstances?.('[data-kt-menu="true"]');
            }, 0);
        }
    }, [showCopyTimesheet, showCopyActivityTimesheet, !isLocked]);
    return (
        <>
            {/* {modalIsOpen && (
                <>
                    <div className="modal drawer-overlay" id="attachmentModel" data-bs-backdrop="static">
                        <div className="modal-dialog modal-xl">
                            <div className="modal-content rounded">
                                <div className='modal-header pb-2'>
                                    <h3 className='headerTitle'>{t('Attachment')}</h3>
                                    <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal' onClick={() => setModalIsOpen(false)}>
                                        <KTIcon iconName='cross' className='fs-1' />
                                    </div>
                                </div>
                                <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                                    <AttachmentUpload
                                        Id={accountEmployeeTimeEntryPeriodId}
                                        onupdateTempAttachmentId={updateTempAttachmentId}
                                        clearRef={attachmentUploadClearRef}
                                        AccountAttachmentTypeId={2}
                                    />
                                    <GetAttachments Id={accountEmployeeTimeEntryPeriodId} AccountAttachmentTypeId={2} IsShowEmployeeInformation={false} />
                                </div>
                                <div className="modal-footer">
                                    <button
                                        type="button"
                                        className="btn btn-secondary"
                                        data-bs-dismiss="modal"
                                        onClick={() => setModalIsOpen(false)}
                                    >
                                        {t('Close')}
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <button ref={modalAttachmentRef} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#attachmentModel">
                        {t('Launch demo modal')}
                    </button>
                </>
            )} */}
            <div className='d-flex align-items-center me-5' style={{ marginTop: 5 }}>
                <Select
                    value={selectedOption}
                    className="basic-single"
                    classNamePrefix="select"
                    isSearchable={isSearchable}
                    name="employeeList"
                    onChange={onEmployeeChange}
                    options={employeeArray}
                    styles={colourStyles}
                />
                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                <div className='d-flex align-items-center flex-shrink-0 tsPeriodDateRange'>
                    <div className='d-flex flex-shrink-0'>
                        <div
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title='Previous'
                        // data-tooltip-id="tooltip-Description"
                        // data-tooltip-content={t("Previous")}
                        // data-tooltip-place="bottom"
                        >
                            <a onClick={() => setTimsheetDate("previous")} className='btn btn-sm btn-icon btn-icon-primary btn-active-color-primary'>
                                <i className="ki-outline ki-left text-primaryTL fs-3"></i>
                            </a>
                        </div>
                        <DatePicker
                            selected={singleDate}
                            onChange={(date) => onDateChange(date)}
                            calendarStartDay={calendarStartDay}
                            customInput={<a style={{ cursor: 'pointer' }} >
                                <div className='d-flex align-items-center flex-wrap' style={{ marginTop: 6.8 }}>
                                    <span className='fs-6 text-gray-700 fw-bold  d-none d-md-block' >{`${getStartDate} - ${getEndDate}`}
                                    {/* <span className='fs-6 text-gray-700 fw-bold  d-none d-md-block' >{`${formatDateWithDateAndMonthName(getStartDate, cultureInfoName.toString())} - ${getEndDate}`} */}
                                    </span>
                                </div>
                            </a>}
                        />
                        <div
                            data-bs-toggle='tooltip'
                            data-bs-placement='top'
                            data-bs-trigger='hover'
                            title='Next'
                        // data-tooltip-id="tooltip-Description"
                        // data-tooltip-content={t("Next")}
                        // data-tooltip-place="bottom"
                        >
                            <a onClick={() => setTimsheetDate("next")} className='btn btn-sm btn-icon btn-icon-primary btn-active-color-primary'>
                                <i className="ki-outline ki-right text-primaryTL fs-3"></i>
                            </a>
                        </div>
                    </div>
                </div>
                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                <a onClick={() => onCurrentDateChange(new Date())} className="btn btn-outline btn-sm btn-outline me-0 mb-0 btn-active-light-dark"
                    style={{ fontSize: 13, fontWeight: 600 }}>{t('Today')}</a>
                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                <div className={clsx('app-navbar-item', itemClass)}>
                    <div className={clsx('cursor-pointer symbol')}
                        data-kt-menu-trigger="{default: 'click'}"
                        data-kt-menu-attach='parent'
                        data-kt-menu-placement='bottom-end'>
                        <span
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content={t("Timesheet Description")}
                            data-tooltip-place="bottom"
                        >
                            <i className="bi bi-file-text fs-3 iconColor"></i>
                        </span>
                    </div>
                    <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-350px'
                        data-kt-menu='true'>
                        <div className={"row tsDescriptionWidget"}>
                            <DescriptionWidget />
                        </div>
                    </div>
                </div>
                {/* <div className={clsx('app-navbar-item', itemClass)}>
                    <div className={clsx('cursor-pointer symbol')}
                        data-kt-menu-trigger="{default: 'click'}"
                        data-kt-menu-permanent='true'
                        data-kt-menu-placement='bottom-end'
                        data-kt-menu-flip='top-end'
                    >
                        <span
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content={"Timer"}
                            data-tooltip-place="bottom"
                        >
                            <i className="bi bi-clock-history fs-3 iconColor"></i>
                        </span>
                    </div>
                    <div className={clsx('menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-325px ')}
                        data-kt-menu='true'>
                        <div className={"row tsCopyWidget"}>
                            <TimesheetTimerWidget />
                        </div>
                    </div>
                </div> */}
                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                {(showCopyTimesheet || showCopyActivityTimesheet) && !isLocked &&
                    <div className={clsx('app-navbar-item ', itemClass)}>
                        <div className={clsx('cursor-pointer symbol')}
                            data-kt-menu-trigger="{default: 'click'}"
                            data-kt-menu-permanent='true'
                            data-kt-menu-placement='bottom-end'
                            data-kt-menu-flip='top-end'
                        >
                            <span
                                className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                                data-tooltip-id="tooltip-Description"
                                data-tooltip-content={t("Copy")}
                                data-tooltip-place="bottom"
                            >
                                <i className="bi bi-files fs-3 iconColor"></i>
                            </span>
                        </div>
                        <div className={clsx('menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-325px ')}
                            data-kt-menu='true'>
                            <div className={"row tsCopyWidget"}>
                                <TimesheetCopyWidget />
                            </div>
                        </div>
                    </div>
                }
                {enableOfflineTimesheet && !isLocked && <div className={clsx('app-navbar-item', itemClass)}>
                    <div className={clsx('cursor-pointer symbol')}
                        data-kt-menu-trigger="{default: 'click'}"
                        data-kt-menu-attach='parent'
                        data-kt-menu-placement='bottom-end'>
                        <span
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content={t("Import/Export")}
                            data-tooltip-place="bottom"
                        >
                            <i className="bi bi-file-earmark-arrow-up fs-3 iconColor"></i>
                        </span>
                    </div>
                    <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-325px'
                        data-kt-menu='true'>
                        <div className={"row tsCopyWidget"}>
                            <TimesheetExportWidget />
                        </div>
                    </div>
                </div>}
                {decimalTotalHours > 0 && isShowAttachment && enableUploadFeature &&
                    <a
                        ref={modelAttachmentRef}
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#attachmentModel"
                        onClick={triggerTimesheetAttachmentView}
                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                        data-tooltip-id="tooltip-Description"
                        data-tooltip-content={t("Attachment")}
                        data-tooltip-place="bottom">
                        <i className="bi bi-paperclip fs-3 iconColor"></i>
                    </a>
                    // <span className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                    //     onClick={(event: any) => {
                    //         event.preventDefault();
                    //         handleAttachment(1);
                    //     }}
                    //     data-tooltip-id="tooltip-Description"
                    //     data-tooltip-content={"Attachment"}
                    //     data-tooltip-place="bottom"
                    // >
                    //     <i className="bi bi-paperclip fs-3 iconColor"></i>
                    // </span>
                }
                {decimalTotalHours > 0 && isShowAttachment && <><div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                    <a
                        ref={modelRef}
                        type="button"
                        data-bs-toggle="modal"
                        data-bs-target="#timesheetPrintModal"
                        onClick={triggerTimesheetPrintView}
                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                        data-tooltip-id="tooltip-Description"
                        data-tooltip-content={t("Print")}
                        data-tooltip-place="bottom">
                        <i className="bi bi-printer fs-3 iconColor"></i>
                    </a>
                    {/* <a
                        ref={modelRef}
                        data-bs-toggle={decimalTotalHours > 0 ? "modal" : ""}
                        data-bs-target="#timesheetPrintModal"
                        onClick={() => { triggerTimesheetPrintView() }}
                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                        data-tooltip-id="tooltip-Description"
                        data-tooltip-content={"Print"}
                        data-tooltip-place="bottom">
                        <i className="bi bi-printer fs-3 iconColor"></i>
                    </a> */}
                </>}
                {decimalTotalHours > 0 && isSubmitted && <><div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                    <a
                        type="button"
                        ref={modelRefSheetApproval}
                        data-bs-toggle="modal"
                        data-bs-target="#timesheetApprovalDetails"
                        className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                        data-tooltip-id="tooltip-Description"
                        data-tooltip-content={t('Approval Details')}
                        data-tooltip-place="bottom"
                        onClick={handleOnClickApprovalEvent}>
                        <i className="bi bi-receipt fs-3 iconColor"></i>
                    </a>
                </>}
                <div className='bullet bg-secondary h-35px w-1px mx-3'></div>
                <div className={clsx('app-navbar-item', itemClass)}>
                    <div className={clsx('cursor-pointer symbol')}
                        data-kt-menu-trigger="{default: 'click'}"
                        data-kt-menu-attach='parent'
                        data-kt-menu-placement='bottom-end'>
                        <span
                            className="btn btn-icon btn-active-light-dark btn-sm ms-0"
                            data-tooltip-id="tooltip-Description"
                            data-tooltip-content={t("More")}
                            data-tooltip-place="bottom"
                        >
                            <i className="bi bi-three-dots fs-3 iconColor"></i>
                        </span>
                    </div>
                    <div className='menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-600 menu-state-bg menu-state-primary fw-bold py-4 fs-6 w-200px'
                        data-kt-menu='true'>
                        <div className={"row"} style={{ marginTop: 0, marginLeft: 1, marginRight: 1, marginBottom: 4 }}>
                            <TimesheetMoreOptionWidget />
                        </div>
                    </div>
                </div>
            </div>
            {/* {accountEmployeeTimeEntryPeriodId != null && <div className='d-flex align-items-center' style={{ marginTop: 5 }}>
                <div className='d-flex align-items-center gap-2 gap-lg-3'>
                    <a
                        //onClick={() => onSubmittedTimesheet()}
                        onClick={() => {
                            if (isLocked) {
                                ShowToast('Warning', 'Timesheet is locked.', 'warning', 'toast-top-right');
                                return;
                            }
                            onSubmittedTimesheet();
                        }}
                        className={"btn btn-primary btn-sm " + (isLocked ? 'disabled' : '')}>
                        <i className="bi bi-pencil-square fs-5 me-1"></i>Submit
                    </a>
                </div>
            </div>} */}
            {accountEmployeeTimeEntryPeriodId != null && (
                <div className='d-flex align-items-center' style={{ marginTop: 5 }}>
                    <div className='d-flex align-items-center gap-2 gap-lg-3'>
                        <a
                            onClick={() => {
                                if (autoTimer) {
                                    dispatch(setTimerPulsing(true));

                                    setTimeout(() => {
                                        dispatch(setTimerPulsing(false));
                                    }, 3000);

                                    ShowToast(
                                        'Warning',
                                        'You cannot submit the timesheet while the timer is running. Please stop the timer first.',
                                        'warning',
                                        'toast-top-right'
                                    );
                                    return;
                                }

                                if (isSubmitButtonLocked) {
                                    ShowToast('Warning', 'Timesheet is locked.', 'warning', 'toast-top-right');
                                    return;
                                }
                                onSubmittedTimesheet();
                            }}
                            className={'btn btn-primary btn-sm ' + (isSubmitButtonLocked ? 'disabled' : '')}
>
                            <i className="bi bi-pencil-square fs-5 me-1"></i>Submit
                        </a>
                    </div>
                </div>
            )}
            {/* <Tooltip id="tooltip-Description" style={{ fontSize: 12, fontWeight: 600 }} /> */}
            <Tooltip id="tooltip-Description"
                style={{ fontSize: 12, fontWeight: 'normal', padding: 8, borderRadius: 6, fontFamily: 'Segoe UI, Tahoma, Geneva, Verdana, sans-serif' }}
            />
            {/* {decimalTotalHours > 0 && <TimesheetPrintViewWidget modelRef={modelRef} accountEmployeeTimeEntryPeriodId={isOpenTimesheetPrintModal} isForTimesheet={true} />} */}
            {/* <TimeSheetApprovalDetails modelRef={modelRefSheetApproval} /> */}
            <button ref={modelRefSheetApproval} type="button" className="btn btn-primary d-none" data-bs-toggle="modal" data-bs-target="#timesheetApprovalDetails">
                Launch demo modal
            </button>
        </>
    )
}

const colourStyles: StylesConfig = {
    control: (styles) => ({ ...styles, backgroundColor: 'white', width: 200, minHeight: '36px', height: '36px', padding: '-1px', borderColor: '#EBECF0' })
}

export { ToolbarTimesheet }